//  api 信息配置
export const API_CONFIG = {
  QUERY_COOKIE_TOKEN: 'rpc/rail.MarsOfficialAccountService.QueryCookieToken',
  GET_SCRAMBLE_COUPONS_INFO:
    'web/promotions/first_anniversary/get_scramble_coupons_info', // 获取抢券信息
  SCRAMBLE_COUPON: 'web/promotions/first_anniversary/scramble_coupon', // 抢限量优惠券
  GET_REWARD_COUPONS_INFO:
    'web/promotions/first_anniversary/get_reward_coupons_info', // 返券模块-获取返券信息
  RECEIVE_REWARD_COUPON:
    'web/promotions/first_anniversary/receive_reward_coupon', // 返券模块-领取返券模块优惠券
  GET_LOTTERY_INIFO: 'web/promotions/first_anniversary/get_lottery_info', // 抽奖模块-获取抽奖模块信息
  DRAW_LOTTERY: 'web/promotions/first_anniversary/draw_lottery', // 抽奖模块-抽奖
  GET_MY_PRIZES: 'web/promotions/first_anniversary/get_my_prizes', // 获取奖品列表,
  REGISTER_EVENT_REMIND: 'web/promotions/first_anniversary/register_event', // 抢券模块-登记活动提醒
  TEST_URL: 'web/promotions/game_release_event/query_user_prize' // mock
};

export const ERROR_CODES = {
  SERVER_ERROR: 2845001,
  INVALID_REQUEST: 2845002,
  INVALID_TOKEN: 2845003,
  EXCEED_REGISTER_TIME: 2845005,
  NOT_IN_EVENT_PERIOD: 2845006
};

export const DEFAULT_ERROR_MESSAGES = {
  [ERROR_CODES.SERVER_ERROR]: '服务器异常',
  [ERROR_CODES.INVALID_REQUEST]: '请求参数不合法',
  [ERROR_CODES.INVALID_TOKEN]: '非法Token',
  [ERROR_CODES.EXCEED_REGISTER_TIME]: '超过预约提醒时间',
  [ERROR_CODES.NOT_IN_EVENT_PERIOD]: '不在活动期间'
};

export const USER_ERROR_MESSAGE = '服务器开了个小差，请稍后再试';

export const PRIZE_ID_MAP = {
  10001: '全场减15元优惠券',
  10002: '全场满200减10元优惠券',
  10003: '全场减5元优惠券',
  10004: '全场减10元优惠券',
  20001: '15QB卡',
  20002: '100QB卡',
  20003: '500QB卡'
};
export const COUPON_PRIZE_ID_MAP = {
  10001: {
    value: 15,
    desc: '无门槛优惠券',
    useScope: '全场',
    availableBeginTime: 1604764801,
    availableEndTime: 1604764802
  }, // '全场减15元优惠券',
  10002: {
    value: 10,
    desc: '满200可用',
    useScope: '满200可用',
    availableBeginTime: 1604764801,
    availableEndTime: 1604764802
  }, // '全场满200减10元优惠券',
  10003: {
    value: 5,
    desc: '无门槛优惠券',
    useScope: '全场',
    availableBeginTime: 1604764801,
    availableEndTime: 1604764802
  }, // '全场减5元优惠券',
  10004: {
    value: 10,
    desc: '无门槛优惠券',
    useScope: '全场',
    availableBeginTime: 1604764801,
    availableEndTime: 1604764802
  } // '全场减10元优惠券',
};
// 返回
export const REWARD_PHASE_MAP = {
  1: {
    // 全场满200减10元优惠券
    value: 10,
    useScope: '满200可用',
    desc: '任意购买一款游戏即可领取'
  },
  2: {
    // 全场减5元优惠券
    value: 5,
    useScope: '全场',
    desc: '使用满200减10元券购买另一款游戏后即可领取'
  },
  3: {
    // 全场减10元优惠券
    value: 10,
    useScope: '全场',
    desc: '使用全场减5元券后即可领取'
  }
};
// 转盘抽奖Id drawLottery
export const LOTTERY_PRIZE_ID_MAP = {
  20001: {
    deg: 150,
    value: 15, // 15QB卡
    image: require('@/assets/img/popbox/coin-one-img.png')
  },
  20002: {
    deg: 30,
    value: 30, // 30QB卡
    image: require('@/assets/img/popbox/coin-two-img.png')
  },
  20003: {
    deg: 270, // 90度
    value: 100, // 100QB卡
    image: require('@/assets/img/popbox/coin-three-img.png')
  }
  // 90, 210, 330
};

export const SCRAMBLE_STATE_MAP = {
  NOT_STARTED: 10, // 未开始'
  STARTING: 20, // '抢券中'
  COMPLETED: 30, //  '已结束'
  RECEIVED: 40 // '已领取'
};

// 优惠券状态
//  0=当前可用的券  1=已经使用过的券  2=已过期的券
export const COUPONS_STATUS = {
  0: '当前可用的券',
  1: '已经使用过的券',
  2: '已过期的券'
};

export const SWIPER_GAME_INFO = [
  {
    name: '汐 Shio',
    originalPrice: '58',
    discountPrice: '38',
    videoId: 'j09766zw3m5',
    image:
      'https://switch-cn.gtgres.com/global-images/f03807f0-9b34-11ea-bb28-bd0c6dbc6ff0.jpg'
  },
  {
    name: '彩虹坠入 Iris Fall',
    originalPrice: '68',
    discountPrice: '44',
    videoId: 'c09709dpvx3',
    image:
      'https://switch-cn.gtgres.com/global-images/73727830-9a59-11ea-bb28-bd0c6dbc6ff0.jpg'
  },
  {
    name: '电竞传奇 eSports Legend',
    originalPrice: '58',
    discountPrice: '38',
    videoId: 'n31028xiujv',
    image:
      'https://switch-cn.gtgres.com/global-images/bd439e80-ac83-11ea-bb28-bd0c6dbc6ff0.jpg'
  },
  {
    name: '只只大冒险 Biped',
    originalPrice: '78',
    discountPrice: '51',
    videoId: 'g310773bvbu',
    image:
      'https://switch-cn.gtgres.com/global-images/6c8552e0-b458-11ea-bb28-bd0c6dbc6ff0.jpg'
  },
  {
    name: '霓虹深渊 Neon Abyss',
    originalPrice: '58',
    discountPrice: '38',
    videoId: 'x0979vi7nfu',
    image:
      'https://switch-cn.gtgres.com/global-images/93b206b0-babb-11ea-bb28-bd0c6dbc6ff0.jpg'
  },
  {
    name: '艾希 Icey',
    originalPrice: '48',
    discountPrice: '33.6',
    videoId: 'q3155poy9q3',
    image:
      'https://switch-cn.gtgres.com/global-image/429dca00-f721-11ea-abbd-e1aeab85f975.jpg'
  },
  {
    name: '恶果之地 Juicy Realm',
    originalPrice: '78',
    discountPrice: '54.6',
    videoId: 'v3155noiirn',
    image:
      'https://switch-cn.gtgres.com/global-image/a8ea2900-f656-11ea-abbd-e1aeab85f975.jpg'
  },
  {
    name: '不思议的皇冠 Crown Trick',
    originalPrice: '88',
    discountPrice: '66',
    videoId: 'x3160dfbizl',
    image:
      'https://switch-cn.gtgres.com/global-image/c9443490-0dc9-11eb-abbd-e1aeab85f975.jpg'
  },
  {
    name: '新 超级马力欧兄弟U 豪华版',
    originalPrice: '299',
    discountPrice: '254.15',
    videoId: 'k003288v0m2',
    image:
      'https://switch-cn.gtgres.com/global-images/16f4fb10-a65b-11ea-bb28-bd0c6dbc6ff0.png'
  },
  {
    name: '超级马力欧 奥德赛',
    originalPrice: '299',
    discountPrice: '254.15',
    videoId: 'v093340pjjc',
    image:
      'https://switch-cn.gtgres.com/global-images/69915b70-a65b-11ea-bb28-bd0c6dbc6ff0.png'
  },
  {
    name: '马力欧卡丁车8 豪华版',
    originalPrice: '299',
    discountPrice: '254.15',
    videoId: 's0932t08mos',
    image:
      'https://switch-cn.gtgres.com/global-images/a2a1f820-a65b-11ea-bb28-bd0c6dbc6ff0.png'
  }
];
